module.exports = __webpack_public_path__ + "img/3.95b0ba7.png";